// Lencana cluster kapal: busur per status, urutannya tetap biar warnanya gak loncat.
import { CLUSTER_COLORS } from './shipStatus.js';

const STATUS_ORDER = ['offline', 'no-gps', 'no-sensor', 'online'];
const RADIUS = 15;

export function shipClusterSvg(statuses, colors = CLUSTER_COLORS) {
  const sorted = (statuses || []).slice().sort(
    (a, b) => STATUS_ORDER.indexOf(a) - STATUS_ORDER.indexOf(b),
  );
  const circumference = 2 * Math.PI * RADIUS;
  const perSegment = circumference / sorted.length;
  const gap = sorted.length > 1 ? Math.min(3, perSegment * 0.25) : 0;
  const arc = sorted.map((status, i) => {
    const content = colors[status] || colors.offline;
    return `<circle cx="18" cy="18" r="${RADIUS}" fill="none" stroke="${content}" stroke-width="4" `
      + `stroke-dasharray="${(perSegment - gap).toFixed(2)} ${(circumference - perSegment + gap).toFixed(2)}" `
      + `stroke-dashoffset="${(-i * perSegment).toFixed(2)}" />`;
  }).join('');

  return '<svg class="ship-cluster" width="36" height="36" viewBox="0 0 36 36">'
    + '<circle cx="18" cy="18" r="13" fill="#ffffff" />'
    + `<g transform="rotate(-90 18 18)">${arc}</g>`
    + `<text x="18" y="18" text-anchor="middle" dominant-baseline="central">${sorted.length}</text>`
    + '</svg>';
}

export default shipClusterSvg;
